import React from 'react';
import { useStudentView } from '../../contexts/StudentViewContext';

export function StudentBanner() {
  const { viewingStudent, clearStudent } = useStudentView();
  if (!viewingStudent) return null;
  return (
    <div style={{ background: 'linear-gradient(135deg, #7c3aed, #3b82f6)', color: '#fff',
      padding: '10px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      borderRadius: '0 0 12px 12px', margin: '0 0 8px', boxShadow: '0 4px 12px rgba(124,58,237,0.25)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'rgba(255,255,255,0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, fontWeight: 800,
          border: '2px solid rgba(255,255,255,0.4)' }}>
          {(viewingStudent.display_name || viewingStudent.username || '?').charAt(0).toUpperCase()}
        </div>
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, opacity: 0.8, letterSpacing: 1.5, textTransform: 'uppercase' }}>Viewing Student</div>
          <div style={{ fontSize: 18, fontWeight: 800 }}>{viewingStudent.display_name || viewingStudent.username}</div>
        </div>
      </div>
      <button onClick={clearStudent}
        style={{ padding: '6px 14px', background: 'rgba(255,255,255,0.2)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', backdropFilter: 'blur(4px)' }}>
        ← My Dashboard
      </button>
    </div>
  );
}
